import { jsxs as r, jsx as l } from "react/jsx-runtime";
import { svgIconStyles as t } from "../svg-icon/SvgIcon.styles.js";
function a({
  label: e,
  className: o,
  size: i,
  ...n
}) {
  return /* @__PURE__ */ r(
    "svg",
    {
      viewBox: "0 0 24 24",
      fill: "none",
      "data-title": "searchOutline",
      stroke: "none",
      role: "img",
      "aria-hidden": !e,
      focusable: "false",
      className: t({ className: o, size: i }),
      ...n,
      children: [
        e && /* @__PURE__ */ l("title", { children: e }),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.6178 18.0321C15.0782 19.2636 13.1252 20 11 20C6.029 20 2 15.971 2 11C2 6.029 6.029 2 11 2C15.971 2 20 6.029 20 11C20 13.1252 19.2636 15.0782 18.0321 16.6178L21.9571 20.5429C22.3476 20.9334 22.3476 21.5666 21.9571 21.9571C21.5666 22.3476 20.9334 22.3476 20.5429 21.9571L16.6178 18.0321ZM18 11C18 14.8664 14.8664 18 11 18C7.13357 18 4 14.8664 4 11C4 7.13357 7.13357 4 11 4C14.8664 4 18 7.13357 18 11Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
export {
  a as SearchOutlineIcon,
  a as default
};
